module.exports = __webpack_public_path__ + "img/mobile-view-en.7b32854.png";